import { buildQuery } from "@/api/apiUtils";
import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  ISiteCreatePayload,
  ISiteListParams,
  ISiteListResponse,
  ISiteDetailResponse,
  ISiteMutationResponse,
} from "@/interface/site.interface";

export const SiteService = {
  createSite: async (
    payload: ISiteCreatePayload,
  ): Promise<ISiteMutationResponse> => {
    return callApi<ISiteMutationResponse>(API_ENDPOINT.createSite, {
      method: "POST",
      data: payload,
    });
  },

  getSiteList: async (
    params: ISiteListParams = {},
  ): Promise<ISiteListResponse> => {
    return callApi<ISiteListResponse>(
      `${API_ENDPOINT.siteList}${buildQuery(params)}`,
      {
        method: "GET",
      },
    );
  },

  getSiteDetail: async (siteId: string): Promise<ISiteDetailResponse> => {
    return callApi<ISiteDetailResponse>(
      API_ENDPOINT.siteDetail.replace(":id", siteId),
      { method: "GET" },
    );
  },

  updateSite: async (
    siteId: string,
    payload: Partial<ISiteCreatePayload>,
  ): Promise<ISiteMutationResponse> => {
    return callApi<ISiteMutationResponse>(
      API_ENDPOINT.siteUpdate.replace(":id", siteId),
      { method: "PUT", data: payload },
    );
  },

  deleteSite: async (siteId: string): Promise<ISiteMutationResponse> => {
    return callApi<ISiteMutationResponse>(
      API_ENDPOINT.siteDelete.replace(":id", siteId),
      { method: "DELETE" },
    );
  },
};
